/**
 * Arena placement maths. Deliberately free of Phaser and DOM imports so the
 * simulation, tooling, and unit tests can reason about bounds in plain Node.
 */
/**
 * Rooms are 15x11 of chunky 50px tiles, which fills the play area the way the
 * arcade games this is modelled on do. `ART_SCALE` carries the same increase
 * into the hand-drawn actors, so characters, fruit, and ice grow with the grid
 * instead of rattling around inside it.
 */
export const ARENA_LAYOUT = Object.freeze({ x: 265, y: 80, tile: 50 });
export const ART_SCALE = ARENA_LAYOUT.tile / 42;
export const ARENA_VISUAL_PADDING = Object.freeze({ left: 6, top: 8, right: 6, bottom: 8 });

export interface ArenaBounds {
  /** Exact logical tile rectangle. */
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
  readonly right: number;
  readonly bottom: number;
  /** Full decorative rectangle, including bevel, outline, and contact shadow. */
  readonly outerX: number;
  readonly outerY: number;
  readonly outerWidth: number;
  readonly outerHeight: number;
  readonly outerRight: number;
  readonly outerBottom: number;
}

export function getArenaBounds(widthInCells: number, heightInCells: number): ArenaBounds {
  const width = widthInCells * ARENA_LAYOUT.tile;
  const height = heightInCells * ARENA_LAYOUT.tile;
  const outerX = ARENA_LAYOUT.x - ARENA_VISUAL_PADDING.left;
  const outerY = ARENA_LAYOUT.y - ARENA_VISUAL_PADDING.top;
  const outerRight = ARENA_LAYOUT.x + width + ARENA_VISUAL_PADDING.right;
  const outerBottom = ARENA_LAYOUT.y + height + ARENA_VISUAL_PADDING.bottom;
  return {
    x: ARENA_LAYOUT.x,
    y: ARENA_LAYOUT.y,
    width,
    height,
    right: ARENA_LAYOUT.x + width,
    bottom: ARENA_LAYOUT.y + height,
    outerX,
    outerY,
    outerWidth: outerRight - outerX,
    outerHeight: outerBottom - outerY,
    outerRight,
    outerBottom,
  };
}
